<style lang="stylus">
    .mo-work--thumb-error
        position: absolute;
        left: 10px;
        top: 10px
    .mo-work .mo-work--author-medal {
        width: 14px;
        height: 14px;
    }
</style>

<template>
    <div style="pointer-events: none">
        <div class="mo-work--wrapper" @click="preview()" style="pointer-events: auto">
            <div class="mo-work--mask" v-if="type == 'center' || type == 'searchPage'">
                <div class="mo-work--usebtn" v-if="work.id !== 1024048" @click.stop="toUse">{{ $t("use") }}</div>
                <div class="mo-work--previewbtn" v-if="type == 'searchPage' && work.id !== 1024048" @click.stop="toPreview">{{ $t("preview") }}</div>
            </div>
            <div
                v-if="work.id !== 1024048"
                class="mo-work--collect"
                @click.prevent.stop="collect()"
                :title="hasCollected ? $t('cancelCollect') : $t('collect')"
            >
                <iconSymbol :name="hasCollected ? 'work-collect3' : 'work-collect2'" />
            </div>
            <div class="mo-work--hot" v-if="index < 10 && isHot" :style="{ background: topColor(index), 'border-color': topColor(index) }">
                {{ `Top ${index + 1}` }}
            </div>
            <img :src="thumbSrc" :title="work.discription" class="mo-work--img" />
            <span class="mo-work--description" v-if="work.id == 1024048">{{ work.description }}</span>

            <template v-if="debug && work.debug && type == 'userWorks'">
                计算过程
                <div v-for="item in work.debug.split('\n')" :key="item.id">
                    {{ item }}
                </div>
            </template>
            <template v-if="type == 'center' || type == 'userWorks' || type == 'searchPage'">
                <!-- 购买状态，只有模板中心里面有 -->
                <span v-if="hasBought" class="mo-work--hint">{{ $t("bought") }}</span>
            </template>
        </div>
        <template
            v-if="type == 'center' || type == 'collection' || type == 'userWorks' || type == 'album' || type == 'albumSearch' || type == 'searchPage'"
        >
            <span class="mo-work--text" style="pointer-events: auto">{{ work.title }}</span>

            <div class="mo-work--number-area" v-if="!isPlugin" style="pointer-events: auto">
                <div class="mo-work--numbers">
                    <div class="mo-ex--icon" style="pointer-events: none">
                        <iconSymbol name="work-pv" />
                        <span>{{ getNumberText(work.pv) }}</span>
                    </div>
                    <template v-if="!internal">
                        <div style="pointer-events: none">
                            <iconSymbol name="work-used" />
                            <span>{{ getNumberText(work.used) }}</span>
                        </div>
                        <div>
                            <iconSymbol name="preview-like" :class="{ 'mo-work--icon__red': hasLiked }" @click.native="like()" />
                            <span>{{ getNumberText(work.like) }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <div style="pointer-events: none">
                            <iconSymbol name="work-used" />
                            <span>{{ getNumberText(work.used) }}</span>
                        </div>
                        <div>
                            <iconSymbol name="work-like" :class="{ 'mo-work--icon__red': hasLiked }" @click.native="like()" />
                            <span>{{ getNumberText(work.like) }}</span>
                        </div>
                    </template>
                </div>

                <span v-if="internal && type == 'userWorks'" class="mo-work--use-condition">{{ priceHint }}</span>
            </div>
            <div v-if="type != 'userWorks'" class="mo-work--author-area" style="pointer-events: auto">
                <div class="mo-work--author-info" @click="showUserWorks()">
                    <iconSymbol v-if="!avatar" class="mo-work--avatar" name="default-avatar" />
                    <img v-if="avatar" :src="avatar" class="mo-work--avatar" alt />
                    <span
                        class="mo-work--author-name"
                        :style="{
                            'max-width': internal ? '100px' : '',
                        }"
                    >
                        {{ safeName }}
                    </span>
                    <img class="fuser-img" v-if="work.fuser" src="@/home/assets/img/work/fuser.png" alt="" />
                    <img class="suffix-img" src="https://images.edrawmax.cn/1.png" v-if="isMedal" alt="" />
                </div>
                <span v-if="internal" class="mo-work--use-condition">{{ priceHint }}</span>
            </div>
        </template>
    </div>
</template>
<i18n>
{
  "zh": {
    "hint": {
      "charge": "收费，",
      "free": "免费",
      "onlyPublic": "仅公开",
      "memberFree": "会员免费"
    },
    "bought": "已购买",
    "use": "使用模板",
    "preview": "预览模板",
    "cancelCollect": "取消收藏",
    "collect": "收藏",
    "freeWork": "免费",
    "payWork": "开通VIP，赠送大额模板金！",
    "vipWork": "VIP专享"
  },
  "en": {
    "hint": {
      "charge": "Pay to use",
      "free": "Free to use",
      "onlyPublic": "View Only",
      "memberFree": "Free for members"
    },
    "bought": "Paid",
    "use": "Use immediately",
    "cancelCollect": "Remove from Favorites",
    "collect": "Favorites",
    "freeWork": "Free",
    "payWork": "Upgrade to Premium and receive big coupon for templates!",
    "vipWork": "Premium"
  },
  "de": {
    "hint": {
      "charge": "Pay to use",
      "free": "Free to use",
      "onlyPublic": "View Only",
      "memberFree": "Free for members"
    },
    "bought": "Paid",
    "cancelCollect": "Von Favoriten entfernen",
    "collect": "Favoriten",
    "freeWork": "Kostenlos",
    "vipWork": "Premium"
  },
  "fr": {
    "hint": {
      "charge": "Pay to use",
      "free": "Free to use",
      "onlyPublic": "View Only",
      "memberFree": "Free for members"
    },
    "bought": "Paid",
    "cancelCollect": "Favori annulé",
    "collect": "Favoris",
    "freeWork": "Gratuit",
    "vipWork": "Premium"
  },
  "es": {
    "hint": {
      "charge": "Pagar para usar",
      "free": "Gratis de usar",
      "onlyPublic": "Solo ver",
      "memberFree": "Gratis para miembros"
    },
    "bought": "Pagados",
    "cancelCollect": "Eliminar de favoritos",
    "collect": "Favoritos",
    "freeWork": "免费",
    "vipWork": "プレミアム"
  },
  "jp": {
    "hint": {
      "charge": "有料",
      "free": "無料",
      "onlyPublic": "View Only",
      "memberFree": "Free for members"
    },
    "bought": "購入済み",
    "cancelCollect": "お気に入りをキャンセルしました",
    "collect": "お気に入り",
    "freeWork": "無料",
    "vipWork": "VIP专享"
  },
  "pt": {
    "hint": {
      "charge": "Pague para usar",
      "free": "Livre para usar",
      "onlyPublic": "Exibir apenas",
      "memberFree": "Grátis para membros"
    },
    "bought": "Pago",
    "cancelCollect": "Remover dos Favoritos",
    "collect": "Coletar",
    "freeWork": "Gratis",
    "vipWork": "Premium"
  },
  "it": {
    "hint": {
      "charge": "Paga per l'uso",
      "free": "Gratis",
      "onlyPublic": "Mostra solo",
      "memberFree": "VIP gratis"
    },
    "bought": "Pagato",
    "cancelCollect": "Rimuovi dai Preferiti",
    "collect": "Preferiti",
    "freeWork": "Gratuita",
    "vipWork": "Premium"
  },
  "tw": {
    "hint": {
      "charge": "收費，",
      "free": "免費",
      "onlyPublic": "僅公開",
      "memberFree": "會員免費"
    },
    "bought": "已購買",
    "cancelCollect": "取消收藏",
    "collect": "收藏",
    "freeWork": "免費",
    "vipWork": "Premium"
  },
  "kr": {
    "hint": {
      "charge": "유료 사용",
      "free": "무료",
      "onlyPublic": "공개",
      "memberFree": "회원 무료"
    },
    "bought": "구매 완료",
    "cancelCollect": "즐겨찾기 취소",
    "collect": "즐겨찾기",
    "freeWork": "무료",
    "vipWork": "프리미엄"
  },
  "id": {
    "hint": {
      "charge": "Penggunaan berbayar",
      "free": "Penggunaan gratis",
      "onlyPublic": "Hanya Lihat",
      "memberFree": "Gratis untuk anggota"
    },
    "bought": "Berbayar",
    "use": "Gunakan segera",
    "cancelCollect": "Hapus dari Favorit",
    "collect": "Favorit",
    "freeWork": "Gratis",
    "vipWork": "Premium"
  }
}
</i18n>
<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import "@/home/style/tplWaterfall.styl";
    @Component({})
    export default class TplWork extends Vue {
        @Prop({
            type: Object,
            required: true,
        })
        work;
        @Prop({
            type: String,
            required: true,
        })
        type;
        @Prop()
        index;

        //正在进行点赞操作
        doingLike: boolean = false;
        doingCollect: boolean = false;

        debug: boolean = window.location.host.indexOf("10") != -1;
        cloneFlag: boolean = false;

        get isHot() {
            return this.$store.state.workFilter.order == "HOT" && this.type == "center";
        }
        get workType() {
            const vip = this.work.member_free;
            const needPay = parseFloat(this.work.price) > 0;
            if (needPay) {
                return 1;
            } else if (vip) {
                return 2;
            } else {
                return 0;
            }
        }
        topColor(index) {
            return ["#DE3131", "#FF8A00", "#FFC700", "#89E82A", "#1FE1ED", "#00C999", "#00BDD7", "#0080DD", "#5D59FF", "#9000D3"][index];
        }
        get isParttime() {
            return this.$store.state.tplCenter.parttime;
        }
        get thumbSrc() {
            //如果是审核或者举报面板，会传一个带时间戳的thumbSrc过来,保证每次刷新之后都会从服务器请求最新的缩略图（因为缩略图可能会被修改，防止修改之后还显示的是浏览器缓存中的）
            let src = window["GLOBAL"].PUBLIC_OSS_HOST + this.work.url + "thumb.png";
            if (this.type == "review" || this.type == "report") src = this.work.thumbSrc;
            return src;
        }
        get medalIds() {
            return this.$store.state.medalIds;
        }
        get isMedal() {
            return this.medalIds.includes(this.work.user_id);
        }
        //头像
        get avatar() {
            let ava = "",
                work = this.work;
            if (work.avatar) ava = "data:image/png;base64," + work.avatar;
            else if (work.avatar_url) ava = work.avatar_url;
            else if (work.user && work.user.avatar) ava = "data:image/png;base64," + work.avatar;
            else if (work.user && work.user.avatar_url) ava = work.user.avatar_url;
            return ava;
        }
        //如果是author电话的话，将电话号码后6位隐藏
        //如果是邮箱的话，隐藏邮箱后缀
        get safeName() {
            let name = this.work.nick_name || this.work.author || (this.work.user && this.work.user.nick_name) || "";
            if (name.match(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)) {
                name = name.substr(0, name.indexOf("@"));
            }
            if (name.match(/^1[3456789]\d{9}$/)) {
                name = name
                    .split("")
                    .map((v, idx) => {
                        if (idx > 4) {
                            return "*";
                        } else {
                            return v;
                        }
                    })
                    .join("");
            }
            return name;
        }
        get priceHint() {
            let work = this.work;
            let hint: any = "";
            if (["1", 1].includes(work.allow_copy)) {
                if (work.price > 0) {
                    hint = "￥" + work.price;
                } else if (["1", 1].includes(work.member_free)) {
                    hint = this.$t("hint.memberFree");
                } else {
                    hint = this.$t("hint.free");
                }
            } else {
                hint = this.$t("hint.onlyPublic");
            }
            return hint;
        }
        //是否点赞过
        get hasLiked() {
            let likeIds = this.$store.state.tplCenter.likeIds;
            return likeIds.includes(this.work.id - 0);
        }
        //是否点赞过
        get hasCollected() {
            let collectIds = this.$store.state.tplCenter.collectIds;
            return collectIds.includes(this.work.id - 0);
        }
        //是否购买过
        get hasBought() {
            let ids = [],
                boughtWorks = this.$store.state.tplCenter.boughtWorks;
            boughtWorks.forEach((item) => {
                ids.push(item.work_id);
            });

            return ids.includes(this.work.id - 0);
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get trackClass() {
            return this.$store.state.trackClass;
        }
        // --testOpenTemplate
        get testOpenTemplate() {
            return this.$store.state.testOpenTemplate;
        }
        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        boughtWorks() {
            return this.$store.state.tplCenter.boughtWorks;
        }
        boughtWorkIds() {
            let ids = [];
            let bWorks = this.$store.state.tplCenter.boughtWorks || [];
            bWorks.forEach((item) => {
                ids.push(item.work_id);
            });
            return ids;
        }
        getNumberText(num) {
            if (Number(num) > 1000) {
                return (Number(num) / 1000).toFixed(1) + "k";
            } else {
                return num;
            }
        }
        openLink() {
            let url = "https://pixso.cn/?from=edrawmax";
            if (this.isPC) {
                (<any>window).$qt.jsCallOpenUrl(url);
            } else {
                let newTab = window.open("about:blank");
                newTab.location.href = url;
            }
        }
        //显示预览界面
        preview() {
            if (this.work.id == 1024048) {
                // pixso引流
                this.openLink();
                return;
            }
            if (this.type == "searchPage") {
                this.toPreview();
                return;
            }
            let ts: any = this;
            let work = this.work;

            let diagramType = "notUseTemplate";
            if (this.$store.state.activeLv3) {
                diagramType = this.$store.state.activeLv3.lv3name;
            } else if (this.$store.state.activeLv2) {
                diagramType = this.$store.state.activeLv2.lv2name;
            } else if (this.$store.state.activeLv1) {
                diagramType = this.$store.state.activeLv1.lv1name;
            }
            this.$gaTrack("Template_clickCommunityTemplate", `diagramType: ${diagramType}`);
            this.sensors.track("clickCommunityTemplate", {
                Catalogues: "Templates",
                diagram_type: diagramType,
                platform: this.isPC ? "desktop" : "online",
            });

            // --testOpenTemplate
            if (this.testOpenTemplate && this.internal) {
                let flag = 0;
                if (work.user_id == this.userInfo.user_id) {
                    // 作品作者
                    flag = 1;
                }
                if (work.member_free && this.vipState) {
                    // 会员免费且用户是会员
                    flag = 1;
                }
                if (work.price > 0 && (this.boughtWorkIds() as any).includes(work.id - 0)) {
                    // 付费作品。用户已付费
                    flag = 1;
                }
                if (work.price <= 0 && work.member_free == 0) {
                    // 免费模板
                    flag = 1;
                }
                if (!(!this.work.member_free && this.work.price == 0)) {
                    if (!this.userInfo.islogin) {
                        flag = 0;
                    }
                }
                if (flag) {
                    this.pcClone();
                    return;
                }
            }

            // WsTrack('Community', "Preview");
            // ts.$track("Community", "Preview");
            //浏览量加一
            let tType = this.work.price > 0 ? "communityPaid" : this.work.member_free ? "communityVip" : "communityFree";
            if (this.params && this.params.id) {
                this.$edApi
                    .viewOrReportWork(
                        Object.assign(
                            {
                                id: this.params.id,
                                workId: work.id - 0,
                                preview: 1,
                            },
                            this.params
                        )
                    )
                    .then(() => {
                        // this.$bus.$emit("updateWorkIds", { id: work.id, type: "pv" });
                        this.work.pv += 1;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            if (this.isPC) {
                // (<any>window).$qt.jsCallUploadData && (<any>window).$qt.jsCallUploadData(JSON.stringify({
                //     type: this.internal ? "S006_Use_Template_8" : "S018_Use_Template_EN",
                //     action: this.internal ? "SL040_Preview_Page" : "SL114_Preview_Page"
                // }));

                ts.$pcTrack(
                    JSON.stringify({
                        type: "openFileProcess",
                        action: "clickTemplate",
                        event: "experience",
                        label: JSON.stringify({
                            template_type: tType,
                        }),
                    })
                );
                ts.$pcTrack(
                    JSON.stringify({
                        type: "Templates",
                        action: "clickCommunityTemplate",
                        event: "experience",
                        label: JSON.stringify({
                            diagram_type: ts.trackClass,
                        }),
                    })
                );
            } else {
                this.sensors.track("previewCommunityTemplate", {
                    Catalogues: "openFileProcess",
                    template_type: tType,
                });
            }

            this.$store.commit("toActiveWork", work);
            this.$store.commit("toTplCenter", {
                name: "previewContext",
                data: this.type,
            });
        }
        toUse() {
            this.$store.commit("toActiveWork", this.work);
            this.$bus.$emit("doClone");
            this.$emit("openTemplate", "create_new");
        }
        toPreview() {
            if (!this.$validateLogin()) return;
            this.$store.commit("setState", {
                type: "showPreviewModalID",
                data: this.work.id,
            });
            this.$store.commit("setState", {
                type: "showPreviewModal",
                data: true,
            });
            this.$emit("openTemplate", "view");
        }
        pcClone() {
            if (this.cloneFlag) return;
            this.cloneFlag = true;
            let { id: workId, path, sign, exp, title: fileName, member_free } = this.work;
            let win: any = window;
            //通知pc端clone
            let callPcAction = (sign, exp, path, checkmfree) => {
                if (this.internal) {
                    sign = encodeURIComponent(sign);
                }
                let param = {
                    id: workId,
                    fileName,
                    sign,
                    exp,
                    obj: path,
                    type: "clone",
                    track: workId + "",
                    accessid: this.OSSAccessKeyId,
                };
                if (checkmfree) {
                    param["checkmfree"] = 1;
                }
                this.cloneFlag = false;
                win.$qt.jsCallCloudFileOperate(JSON.stringify(param));
            };

            //如果是会员免费，先调接口获取作品源文件下载信息
            if (member_free || this.work.user_id == this.userInfo.user_id) {
                this.$edApi
                    .getWorkDownInfo({
                        id: this.params.id,
                        workId,
                        token: this.params.token,
                    })
                    .then((data) => {
                        sign = data.sign;
                        exp = data.exp;
                        path = data.path;
                        callPcAction(sign, exp, path, true);
                    })
                    .catch((error) => {
                        this.cloneFlag = false;
                    });
            } else {
                //如果是已购买的，从购买信息中获取sign和exp。如果是免费的就用preItem中的sign和exp
                if (this.work.price > 0) {
                    let boughtInfo = (this.boughtWorks() as any).find((boughtWork) => {
                        if (boughtWork.work_id == workId) return boughtWork;
                    });

                    sign = boughtInfo.sign;
                    exp = boughtInfo.exp;
                    path = boughtInfo.path;
                }
                callPcAction(sign, exp, path, false);
            }
            // this.closePre();
        }
        //点赞或取消赞
        like() {
            let ts: any = this;
            // WsTrack("Community", "Like");
            // ts.$track("Community", "Like");
            let userInfo = this.$store.state.userInfo;
            if (!userInfo && this.$store.state.user) {
                userInfo = this.$store.state.user.userInfo;
            }
            if (this.isPC && userInfo && !userInfo.islogin) {
                (<any>window).$qt.jsCallUpdateLoginTrigger && (<any>window).$qt.jsCallUpdateLoginTrigger("likesTemplates");
            }
            if (!this.$validateLogin()) return;
            if (this.doingLike) return;
            let workId = this.work.id - 0;
            this.doingLike = true;
            if (this.hasLiked) {
                //取消点赞
                this.$edApi
                    .likeOrCollectWork({
                        id: this.params.id,
                        token: this.params.token,
                        workId,
                        like: 0,
                    })
                    .then(() => {
                        this.$bus.$emit("updateWorkIds", { id: workId, type: "dislike" });
                        this.$bus.$emit("updateWorkIds2", { id: workId, type: "dislike" });
                        this.doingLike = false;
                    });
            } else {
                //点赞
                this.$edApi
                    .likeOrCollectWork({
                        id: this.params.id,
                        token: this.params.token,
                        workId,
                        like: 1,
                    })
                    .then(() => {
                        this.sensors.track("likeTemplate", {
                            Catalogues: "publish template",
                        });
                        this.$bus.$emit("updateWorkIds", { id: workId, type: "like" });
                        this.$bus.$emit("updateWorkIds2", { id: workId, type: "like" });
                        this.doingLike = false;
                        if (this.isPC) {
                            this.$pcTrack(
                                JSON.stringify({
                                    type: "publish template",
                                    action: "likeTemplate",
                                    event: "experience",
                                })
                            );
                        }
                    });
            }
        }
        collect() {
            let userInfo = this.$store.state.userInfo;
            if (!userInfo && this.$store.state.user) {
                userInfo = this.$store.state.user.userInfo;
            }
            if (this.isPC && userInfo && !userInfo.islogin) {
                (<any>window).$qt.jsCallUpdateLoginTrigger && (<any>window).$qt.jsCallUpdateLoginTrigger("favoritesTemplates");
            }
            if (!this.$validateLogin()) return;
            if (this.doingCollect) return;
            this.doingCollect = true;

            if (this.type == "searchPage") {
                this.$emit("trackTemplate", "favorite");
            }

            let id = this.work.id - 0;
            if (this.hasCollected) {
                // 取消收藏
                this.$edApi
                    .likeOrCollectWork({
                        id: this.params.id,
                        token: this.params.token,
                        workId: id,
                        collect: 0,
                    })
                    .then(() => {
                        this.$bus.$emit("updateWorkIds", { id, type: "discollect" });
                        this.$bus.$emit("updateWorkIds2", { id, type: "discollect" });
                        this.doingCollect = false;
                        this.$emit("cancelCollect", id);
                    });
            } else {
                // 收藏
                this.$edApi
                    .likeOrCollectWork({
                        id: this.params.id,
                        token: this.params.token,
                        workId: id,
                        collect: 1,
                    })
                    .then(() => {
                        // 首次操作时弹窗提示
                        if (!localStorage.getItem("checkCollect")) {
                            localStorage.setItem("checkCollect", "true");
                            this.$store.commit("setState", {
                                type: "collectModal",
                                data: true,
                            });
                        }
                        this.$bus.$emit("updateWorkIds", { id, type: "collect" });
                        this.$bus.$emit("updateWorkIds2", { id, type: "collect" });
                        this.doingCollect = false;
                    });
            }
        }

        showUserWorks() {
            if (!this.$validateLogin()) return;
            let ts: any = this;
            // WsTrack("Community", "WorkCenter", "Show");
            // ts.$track("Community", "WorkCenter", "Show");
            let id = this.work.user_id,
                fuser = this.work.fuser;
            if (this.isPC && this.internal) {
                this.$store.commit("toTplCenter", {
                    name: "showUserWorks",
                    data: true,
                });

                this.$store.commit("toVisitUser", {
                    id,
                    fuser: fuser ? true : false,
                });
                this.$store.commit("userPage/clickUserWordId", id);
            } else {
                let path = this.internal ? "templates/user" : "templates/users";
                let href = `${window.location.origin}/${path}/${id}`;
                if (this.isPC) {
                    (<any>window).$qt.jsCallOpenUrl(href);
                } else {
                    window.open(href);
                }
            }
        }
        deleteWorkFromAlbum() {
            this.$bus.$emit("deleteWorkFromAlbum", this.work.id);
        }
        addWorkToAlbum() {
            this.$bus.$emit("addWorkToAlbum", this.work.id);
        }
    }
</script>
